import React, { useEffect } from "react";
import { useGetAmenityAvailability } from "../../../../../../../../hook/getAmenityAvailabilityHook";
import * as HMS from "../../../../../../common/component/Index";
import DEFINE, {
  DETAIL_ACTIONS,
  FEATURE_FLAGS,
  PATHS,
  TOUR_TABS,
  OBJECT_TYPE,
  OBJECT_TYPE_FOR_VINWONDER7,
} from "../../../../../../../../constants/Define";
import * as Func from "../../../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import AntSelect, {
  AntOption,
} from "../../../../../../common/component/AntSelect";

const SelectAmenity = (props) => {
  //! State
  const {
    data: amentityData,
    isLoading,
    error,
    refresh,
  } = useGetAmenityAvailability();
  const action = DETAIL_ACTIONS.CREATE;
  const { tourTicket, validation, onChangeAmenity, selectFilterSearch } = props;
  const { t } = useTranslation();
  const { languageCode } = tourTicket;
  const amentityOptions = amentityData?.map((el) => {
    const transactionArr = el?.translations.map((el) => el);

    return {
      amentityId: el?.id,
      name: el?.name,
      code: el?.code,
      translations: transactionArr,
    };
  });

  const value = tourTicket.amentity?.map((e) => e.amentityId);
  //! Function

  const onChangeAmenityState = (ids) => {
    const amenitySelected = amentityOptions.filter((e) =>
      ids.includes(e.amentityId)
    );

    onChangeAmenity(amenitySelected);
  };

  //! Effect

  //! Render
  return (
    <HMS.FormWrapperInputComponent
      isRequired={false}
      isValidation={false}
      // dataValidation={value}
      labelTitle={t(`item.tourTicket.amenity`)}
      visible={action !== DETAIL_ACTIONS.TRANSLATE}
    >
      <AntSelect
        className="select-types"
        showArrow
        mode="multiple"
        name="propertyIds"
        placeholder={Func.capitalizeFirstLetter(
          (
            t("placeHolderForm.select") +
            " " +
            t("item.tourTicket.amenity")
          ).toLowerCase()
        )}
        value={value}
        onChange={onChangeAmenityState}
        filterOption={selectFilterSearch}
        style={{ width: "100%" }}
      >
        {(amentityOptions || []).map((el, index) => {
          const nameLanguage = el?.translations.filter(
            (el) => el?.languageCode === languageCode
          )[0]?.name;

          if (!nameLanguage) {
            return (
              <AntOption key={el?.amentityId} value={el.amentityId}>
                {el?.name}
              </AntOption>
            );
          } else {
            return (
              <AntOption key={el?.amentityId} value={el.amentityId}>
                {nameLanguage}
              </AntOption>
            );
          }
        })}
      </AntSelect>
    </HMS.FormWrapperInputComponent>
  );
};

export default SelectAmenity;
